import { Component, OnInit, OnChanges } from '@angular/core';
import { Routes, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BaMenuService } from "../../../theme";
import { LoginService } from "../service/login/login.service";
import { AccountService } from "../service/account/account.service";
import { Message } from "primeng/primeng";
import { Permission } from "../class/permission";
import { NotificationsService } from "../../../theme/services/notifications/notifications.service";

@Component({
  selector: "app-pages",
  templateUrl: "./pages.component.html",
  styleUrls: ["./pages.component.scss"],
})
export class PagesComponent implements OnInit, OnChanges {
  currentLang: string;
  public msgs: Message[] = [];
  public ImgPerfile: string;
  public menu: any;
  public permissions: Permission[];

  constructor(
    private _menuService: BaMenuService,
    private loginService: LoginService,
    private accountService: AccountService,
    private translate: TranslateService,
    public router: Router,
    // public baPageTop: BaPageTop,
    // public accountComponent: AccountComponent,
    private notificationsService: NotificationsService
  ) {
    this.currentLang = "es";
    this.translate.setDefaultLang(this.currentLang);
    this.translate.use(this.currentLang);
  }

  ngOnInit() {
    this.ImgPerfile = JSON.parse(localStorage.getItem("profile")).avatar;
    this.currentLang = JSON.parse(localStorage.getItem("profile")).language;

    this.translate.setDefaultLang(this.currentLang);
    this.translate.use(this.currentLang);
    this.permissions = JSON.parse(localStorage.getItem("permissions"));
    this.createMenu();
    // this.getAccount();
    // this.getAccountPermissions();
  }

  ngOnChanges() {
    // this.getAccount();
    // this.getAccountPermissions();
  }

  public getAccount() {
    if (this.loginService.loggedIn()) {
      this.accountService
        .getAccount()
        .toPromise()
        .then(
          (response) => {
            localStorage.setItem("profile", JSON.stringify(response.json()));
            this.ImgPerfile = JSON.parse(
              localStorage.getItem("profile")
            ).avatar;
            this.currentLang = JSON.parse(
              localStorage.getItem("profile")
            ).language;

            this.translate.setDefaultLang(this.currentLang);
            this.translate.use(this.currentLang);
            // this.changeLanguage(this.currentLang);
          },
          (error) => {
            if (error.status === 401) {
              // localStorage.removeItem('token');
              // this.router.navigateByUrl('/login');
            }
          }
        );
    }
  }

  public getAccountPermissions() {
    if (this.loginService.loggedIn()) {
      this.accountService
        .getAccountPermissions()
        .toPromise()
        .then(
          (response) => {
            this.permissions = response.json();
            localStorage.setItem(
              "permissions",
              JSON.stringify(this.permissions)
            );

            this.createMenu();
            // this.changeLanguage(this.currentLang);
          },
          (error) => {
            if (error.status === 401) {
              // localStorage.removeItem('token');
              // this.router.navigateByUrl('/login');
            }
          }
        );
    }
  }

  public createMenu() {
    this.menu = [
      {
        path: "pages",
        children: [
          {
            path: "account",
            data: {
              menu: {
                title: "account",
                icon: "fa fa-home",
                selected: false,
                expanded: false,
                hidden: true,
                order: 0,
              },
            },
          },
          {
            path: "dashboard",
            data: {
              menu: {
                title: "dashboard",
                icon: "fa fa-home",
                selected: false,
                expanded: false,
                hidden: false,
                order: 0,
              },
            },
          },
          {
            path: "reports",
            data: {
              menu: {
                title: "reports",
                icon: "fa fa-folder-open",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu("get reports", this.permissions),
                order: 200,
              },
            },
            children: [
              {
                path: "financial-dashboard",
                data: {
                  menu: {
                    title: "financial dashboard",
                    icon: "fa fa-file-image-o",
                    hidden: this.isHiddenMenu(
                      "get financial report",
                      this.permissions
                    ),
                  },
                },
              },
              {
                path: "sorttime-companies-dashboard",
                data: {
                  menu: {
                    title: "sorttime companies dashboard",
                    icon: "fa fa-file-image-o",
                    hidden: this.isHiddenMenu(
                      "get sorttime companies report",
                      this.permissions
                    ),
                  },
                },
              },
            ],
          },
          {
            path: "tips",
            data: {
              menu: {
                title: "tips",
                icon: "fa fa-file-image-o",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu("get tips", this.permissions),
                order: 0,
              },
            },
          },
          {
            path: "virtual-office",
            data: {
              menu: {
                title: "virtual office",
                icon: "fa fa-archive",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu(
                  "get virtual office",
                  this.permissions
                ),
                order: 0,
              },
            },
          },
          {
            path: "directorys",
            data: {
              menu: {
                title: "directorys",
                icon: "fa fa-address-book-o",
                selected: false,
                expanded: false,
                hidden: !this.isHiddenMenu(
                  "get user company",
                  this.permissions
                ),
                order: 0,
              },
            },
          },
          {
            path: "vacations",
            data: {
              menu: {
                title: "vacations",
                icon: "fa fa-plane",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu("get vacations", this.permissions),
                order: 0,
              },
            },
          },
          {
            path: "schedule-employees",
            data: {
              menu: {
                title: "schedule employees",
                icon: "fa fa-calendar",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu(
                  "get schedule-employee",
                  this.permissions
                ),
                order: 0,
              },
            },
          },
          {
            path: "customer-guides",
            data: {
              menu: {
                title: "customer-guides",
                icon: "fa fa-address-book-o",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu(
                  "get customer-guide",
                  this.permissions
                ),
                order: 0,
              },
            },
          },
          {
            path: "customer-guides-synergo",
            data: {
              menu: {
                title: "customer-guides-synergo",
                icon: "fa fa-address-book-o",
                selected: false,
                expanded: false,
                //hidden: this.isHiddenMenu('get customer-guide', this.permissions),
                //order: 0
              },
            },
          },
          {
            path: "selection",
            data: {
              menu: {
                title: "selection",
                icon: "fa fa-folder-open",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu("get selection", this.permissions),
                order: 200,
              },
            },
            children: [
              {
                path: "candidates",
                data: {
                  menu: {
                    title: "candidates",
                    icon: "fa fa-user-circle",
                    hidden: this.isHiddenMenu(
                      "get candidate",
                      this.permissions
                    ),
                  },
                },
              },
              {
                path: "candidates-synergo",
                data: {
                  menu: {
                    title: "candidates synergo",
                    icon: "fa fa-user-circle",
                    //hidden: this.isHiddenMenu('get candidate', this.permissions),
                  },
                },
              },
              {
                path: "candidate-comments",
                data: {
                  menu: {
                    title: "candidate comments",
                    icon: "fa fa-user-circle",
                    hidden: this.isHiddenMenu(
                      "get candidate comment",
                      this.permissions
                    ),
                  },
                },
              },
              /* {
                  path: 'daily-visits',
                  data: {
                      menu: {
                          title: 'daily visits',
                          icon: 'fa fa-user-circle',
                          hidden: this.isHiddenMenu('get daily visit', this.permissions),
                      }
                  }
              }, */
              {
                path: "requisitions",
                data: {
                  menu: {
                    title: "requisitions",
                    icon: "fa fa-list",
                    hidden: this.isHiddenMenu(
                      "get requisition",
                      this.permissions
                    ),
                  },
                },
              },
              {
                path: "citations",
                data: {
                  menu: {
                    title: "operations",
                    icon: "fa fa-list",
                    hidden: this.isHiddenMenu("get citation", this.permissions),
                  },
                },
              },
              {
                path: "recruitments",
                data: {
                  menu: {
                    title: "recruitments",
                    icon: "fa fa-list",
                    hidden: this.isHiddenMenu(
                      "get recruitment",
                      this.permissions
                    ),
                  },
                },
              },
              /* {
                  path: 'requisition-tasks',
                  data: {
                      menu: {
                          title: 'requisition task',
                          icon: 'fa fa-user-circle',
                          hidden: this.isHiddenMenu('get requisition task', this.permissions),
                      }
                  }
              }, */
              /* {
                  path: 'selection-analyst',
                  data: {
                      menu: {
                          title: 'selection analyst',
                          icon: 'fa fa-user-circle',
                          hidden: this.isHiddenMenu('get selection analyst', this.permissions),
                      }
                  }
              }, */
              {
                path: "profile-surveis",
                data: {
                  menu: {
                    title: "profile surveis",
                    icon: "fa fa-book",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu(
                      "get profile-survey",
                      this.permissions
                    ),
                    order: 0,
                  },
                },
              },
              {
                path: "list-document-profile-surveis",
                data: {
                  menu: {
                    title: "list document profile surveis",
                    icon: "fa fa-book",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu(
                      "get list document profile survey",
                      this.permissions
                    ),
                    order: 0,
                  },
                },
              },
              {
                path: "document-profile-surveys",
                data: {
                  menu: {
                    title: "document profile surveys",
                    icon: "fa fa-book",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu(
                      "get document profile survey",
                      this.permissions
                    ),
                    order: 0,
                  },
                },
              },
            ],
          },

          /* {
              path: 'operations',
              data: {
              menu: {
                  title: 'operations',
                  icon: 'fa fa-microchip',
                  selected: false,
                  expanded: false,
                  hidden: this.isHiddenMenu('get citation module', this.permissions),
                  order: 200,
              }
              },
              children: [
                  {
                      path: 'profile-surveis',
                      data: {
                          menu: {
                              title: 'profile surveis',
                              icon: 'fa fa-child',
                              selected: false,
                              expanded: false,
                              hidden: this.isHiddenMenu('get profile-survey', this.permissions),
                              order: 0
                          }
                      }
                  },
                  {
                      path: 'requisitions',
                      data: {
                      menu: {
                          title: 'requisitions',
                          icon: 'fa fa-users',
                          hidden: this.isHiddenMenu('get requisition', this.permissions),
                      }
                      }
                  },
                  {
                      path: 'citations',
                      data: {
                      menu: {
                          title: 'operation',
                          icon: 'fa fa-briefcase',
                          hidden: this.isHiddenMenu('get citation', this.permissions),
                      }
                      }
                  },
              ]
          }, */

          /* {
              path: 'synergo',
              data: {
                  menu: {
                      title: 'Synergo',
                      icon: 'fa fa-list',
                      selected: false,
                      expanded: false,
                      hidden: this.isHiddenMenu('get synergo', this.permissions),
                      order: 200,
                  }
              },
              children: [
                  {
                      path: 'synergo-citations',
                      data: {
                          menu: {
                              title: 'synergo citations',
                              icon: 'fa fa-users',
                              hidden: this.isHiddenMenu('get synergo', this.permissions),
                          }
                      }
                  },
                  {
                      path: 'synergo-requisitions',
                      data: {
                      menu: {
                          title: 'synergo requisitions',
                          icon: 'fa fa-users',
                          hidden: this.isHiddenMenu('get synergo', this.permissions),
                      }
                      }
                  }
              ]
          }, */

          {
            path: "hire",
            data: {
              menu: {
                title: "hire",
                icon: "fa fa-folder-open",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu("get hire", this.permissions),
                order: 200,
              },
            },
            children: [
              {
                path: "archives",
                data: {
                  menu: {
                    title: "archives",
                    icon: "fa fa-archive",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu("get archives", this.permissions),
                    order: 0,
                  },
                },
              },
              {
                path: "folder-share",
                data: {
                  menu: {
                    title: "folder share",
                    icon: "fa fa-archive",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu(
                      "get folder-share",
                      this.permissions
                    ),
                    order: 0,
                  },
                },
              },
              {
                path: "citations",
                data: {
                  menu: {
                    title: "operations",
                    icon: "fa fa-list",
                    hidden: this.isHiddenMenu("get citation", this.permissions),
                  },
                },
              },
              {
                path: "hire-analyst",
                data: {
                  menu: {
                    title: "hire analyst",
                    icon: "fa fa-list",
                    hidden: this.isHiddenMenu(
                      "get hire analyst",
                      this.permissions
                    ),
                  },
                },
              },
            ],
          },
          {
            path: "digital-documentation",
            data: {
              menu: {
                title: "digital documentation",
                icon: "fa fa-folder-open",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu("get legal", this.permissions),
                order: 200,
              },
            },
            children: [
              {
                path: "contracts",
                data: {
                  menu: {
                    title: "contracts",
                    icon: "fa fa-file-text-o",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu("get legal", this.permissions),
                    order: 0,
                  },
                },
              },
              {
                path: "expired-documents",
                data: {
                  menu: {
                    title: "expired-documents",
                    icon: "fa fa-file-text-o",
                    selected: false,
                    expanded: false,
                    hidden: !this.isHiddenMenu(
                      "get user company",
                      this.permissions
                    ),
                    order: 0,
                  },
                },
              },
            ],
          },
          {
            path: "service-client",
            data: {
              menu: {
                title: "service client",
                icon: "fa fa-folder-open",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu(
                  "get gestion-sac module",
                  this.permissions
                ),
                order: 200,
              },
            },
            children: [
              {
                path: "gestionSACs",
                data: {
                  menu: {
                    title: "gestionSACs",
                    icon: "fa fa-handshake-o",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu(
                      "get gestion-sac",
                      this.permissions
                    ),
                    order: 0,
                  },
                },
              },
              {
                path: "radications-ss",
                data: {
                  menu: {
                    title: "radications-ss",
                    icon: "fa fa-file-text-o",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu(
                      "get radications-ss",
                      this.permissions
                    ),
                    order: 0,
                  },
                },
              },
              {
                path: "worker-cares",
                data: {
                  menu: {
                    title: "worker cares",
                    icon: "fa fa-newspaper-o",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu(
                      "get worker-care",
                      this.permissions
                    ),
                    order: 0,
                  },
                },
                children: [
                  {
                    path: "worker-cares-reported",
                    data: {
                      menu: {
                        title: "worker cares reported",
                        icon: "fa fa-newspaper-o",
                        hidden: this.isHiddenMenu(
                          "get worker-care",
                          this.permissions
                        ),
                      },
                    },
                  },
                  /* {
                      path: 'worker-cares-asigned',
                      data: {
                      menu: {
                          title: 'worker cares asigned',
                          icon: 'fa fa-newspaper-o',
                          hidden: this.isHiddenMenu('get worker-care', this.permissions),
                      }
                      }
                  }, */
                  {
                    path: "worker-cares-verification",
                    data: {
                      menu: {
                        title: "worker cares verification",
                        icon: "fa fa-newspaper-o",
                        hidden: this.isHiddenMenu(
                          "get worker-care",
                          this.permissions
                        ),
                      },
                    },
                  },
                ],
              },
            ],
          },
          /* {
              path: 'management-claro',
              data: {
              menu: {
                  title: 'management claro',
                  icon: 'fa fa-server',
                  selected: false,
                  expanded: false,
                  hidden: this.isHiddenMenu('get management claro', this.permissions),
                  order: 200,
              }
              },
              children: [
              {
                  path: 'stations',
                  data: {
                  menu: {
                      title: 'stations',
                      icon: 'fa fa-building',
                      hidden: this.isHiddenMenu('get station', this.permissions),
                  }
                  }
              },
              {
                  path: 'manager',
                  data: {
                  menu: {
                      title: 'manager',
                      icon: 'fa fa-users',
                      hidden: this.isHiddenMenu('get manager sercontratos', this.permissions),
                  }
                  }
              },
              {
                  path: 'auxiliar',
                  data: {
                  menu: {
                      title: 'auxiliar',
                      icon: 'fa fa-users',
                      hidden: this.isHiddenMenu('get auxiliar', this.permissions),
                  }
                  }
              },
              {
                  path: 'openings-stations',
                  data: {
                  menu: {
                      title: 'openings stations',
                      icon: 'fa fa-key',
                      hidden: this.isHiddenMenu('get opening station', this.permissions),
                  }
                  }
              },
              {
                  path: 'minutes',
                  data: {
                  menu: {
                      title: 'minutes',
                      icon: 'fa fa-key',
                      hidden: this.isHiddenMenu('get minute', this.permissions),
                  }
                  }
              },
              {
                  path: 'routes',
                  data: {
                  menu: {
                      title: 'routes',
                      icon: 'fa fa-road',
                      hidden: this.isHiddenMenu('get route', this.permissions),
                  }
                  }
              },
              {
                  path: 'management-claro',
                  data: {
                  menu: {
                      title: 'management claro',
                      icon: 'fa fa-building',
                      hidden: this.isHiddenMenu('get management claro', this.permissions),
                  }
                  }
              },
              {
                path: 'inspection-equipments',
                data: {
                menu: {
                    title: 'inspection equipments',
                    icon: 'fa fa-building',
                    hidden: this.isHiddenMenu('get inspection equipment', this.permissions),
                }
                }
              },
              {
                path: 'inspections',
                data: {
                menu: {
                    title: 'inspections',
                    icon: 'fa fa-building',
                    hidden: this.isHiddenMenu('get inspection', this.permissions),
                }
                }
              },
              {
                path: 'thefts',
                data: {
                menu: {
                    title: 'thefts',
                    icon: 'fa fa-building',
                    hidden: this.isHiddenMenu('get theft', this.permissions),
                }
                }
              }]
          }, */
          {
            path: "findings",
            data: {
              menu: {
                title: "findings",
                icon: "fa fa-eye-slash",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu("get findings", this.permissions),
                order: 0,
              },
            },
          },
          {
            path: "pqrs",
            data: {
              menu: {
                title: "pqrs",
                icon: "fa fa-folder-open",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu("get pqr", this.permissions),
                order: 0,
              },
            },
            children: [
              {
                path: "pqrs_reported",
                data: {
                  menu: {
                    title: "pqrs reported",
                    icon: "fa fa-list",
                    hidden: this.isHiddenMenu("get pqr", this.permissions),
                  },
                },
              },
              {
                path: "pqrs_asigned",
                data: {
                  menu: {
                    title: "pqrs asigned",
                    icon: "fa fa-list",
                    hidden: this.isHiddenMenu(
                      "get pqr asigned",
                      this.permissions
                    ),
                  },
                },
              },
              {
                path: "pqrs_verification",
                data: {
                  menu: {
                    title: "pqrs verification",
                    icon: "fa fa-list",
                    hidden: this.isHiddenMenu(
                      "get pqr verification",
                      this.permissions
                    ),
                  },
                },
              },
              {
                path: "pqrs_typification",
                data: {
                  menu: {
                    title: "pqrs typification",
                    icon: "fa fa-list",
                    hidden: this.isHiddenMenu(
                      "get pqr typification",
                      this.permissions
                    ),
                  },
                },
              },
            ],
          },
          {
            path: "bank-books",
            data: {
              menu: {
                title: "bank books",
                icon: "fa fa-university",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu("get bank", this.permissions),
                order: 200,
              },
            },
            children: [
              {
                path: "banks",
                data: {
                  menu: {
                    title: "banks",
                    icon: "fa fa-building",
                    hidden: this.isHiddenMenu("get bank", this.permissions),
                  },
                },
              },
              {
                path: "bank-books",
                data: {
                  menu: {
                    title: "bank books",
                    icon: "fa fa-building",
                    hidden: this.isHiddenMenu(
                      "get bank books",
                      this.permissions
                    ),
                  },
                },
              },
            ],
          },
          {
            path: "disabilities",
            data: {
              menu: {
                title: "disabilities",
                icon: "fa fa-stethoscope",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu("get disabilities", this.permissions),
                order: 0,
              },
            },
          },
          {
            path: "medical-cases",
            data: {
              menu: {
                title: "medical cases",
                icon: "fa fa-medkit",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu(
                  "get medical cases",
                  this.permissions
                ),
                order: 0,
              },
            },
          },
          // {
          //   path: "medical-exams",
          //   data: {
          //     menu: {
          //       title: "medical exams",
          //       icon: "fa fa-medkit",
          //       selected: false,
          //       expanded: false,
          //       hidden: this.isHiddenMenu(
          //         "get medical exams",
          //         this.permissions
          //       ),
          //       order: 0,
          //     },
          //   },
          // },
          {
            path: "innovation",
            data: {
              menu: {
                title: "innovation",
                icon: "fa fa-laptop",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu("get innovation", this.permissions),
                order: 0,
              },
            },
            children: [
              {
                path: "systems-requests",
                data: {
                  menu: {
                    title: "systems requests",
                    icon: "fa fa-desktop",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu(
                      "get systems requests",
                      this.permissions
                    ),
                    order: 0,
                  },
                },
              },
              {
                path: "development-requests",
                data: {
                  menu: {
                    title: "development requests",
                    icon: "fa fa-code",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu(
                      "get development requests",
                      this.permissions
                    ),
                    order: 0,
                  },
                },
              },
              {
                path: "systems-inventory-requests",
                data: {
                  menu: {
                    title: "systems inventory requests",
                    icon: "fa fa-desktop",
                    selected: false,
                    expanded: false,
                    hidden: this.isHiddenMenu(
                      "get systems inventory requests",
                      this.permissions
                    ),
                    order: 0,
                  },
                },
              },
            ],
          },

          {
            path: "administration",
            data: {
              menu: {
                title: "administration",
                icon: "fa fa-cog",
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu(
                  "get administration",
                  this.permissions
                ),
                order: 200,
              },
            },
            children: [
              {
                path: "companies",
                data: {
                  menu: {
                    title: "companies",
                    icon: "fa fa-building",
                    hidden: this.isHiddenMenu("get company", this.permissions),
                  },
                },
              },
              {
                path: "venues",
                data: {
                  menu: {
                    title: "venues",
                    icon: "fa fa-building",
                    hidden: this.isHiddenMenu("get venue", this.permissions),
                  },
                },
              },
              {
                path: "departments",
                data: {
                  menu: {
                    title: "departments",
                    icon: "fa fa-building",
                    hidden: this.isHiddenMenu(
                      "get department",
                      this.permissions
                    ),
                  },
                },
              },
              {
                path: "employee-positions",
                data: {
                  menu: {
                    title: "employee positions",
                    icon: "fa fa-user-plus",
                    hidden: this.isHiddenMenu(
                      "get employee-position",
                      this.permissions
                    ),
                  },
                },
              },
              {
                path: "employees",
                data: {
                  menu: {
                    title: "employees",
                    icon: "fa fa-user-plus",
                    hidden: this.isHiddenMenu("get employee", this.permissions),
                  },
                },
              },
              {
                path: "users",
                data: {
                  menu: {
                    title: "users",
                    icon: "fa fa-user-plus",
                    hidden: this.isHiddenMenu("get user", this.permissions),
                  },
                },
              },
              {
                path: "roles",
                data: {
                  menu: {
                    title: "roles",
                    icon: "fa fa-user-secret",
                    hidden: this.isHiddenMenu("get role", this.permissions),
                  },
                },
              },
              {
                path: "permissions",
                data: {
                  menu: {
                    title: "permissions",
                    icon: "fa fa-terminal",
                    hidden: this.isHiddenMenu(
                      "get permission",
                      this.permissions
                    ),
                  },
                },
              },
            ],
          },
        ],
      },
    ];
    this._menuService.updateMenuByRoutes(<Routes>this.menu);
  }

  public isHiddenMenu(element, list) {
    let hidden = false;
    let itera = 0;
    list.forEach((elementList) => {
      if (elementList.name === element) {
        hidden = true;
      }
      itera++;
    });
    return !hidden;
  }

  // public changeLanguage(lang) {
  //     this.accountService.updateProfile({'language': lang}).toPromise().then(
  //         response => {
  //             this.currentLang = lang;
  //             this.translate.use(this.currentLang);
  //             // this.baPageTop.languageChaged(this.lang);
  //             // this.accountComponent.getProfile();
  //             this._menuService.updateMenuByRoutes(<Routes> this.menu);
  //         },
  //         error => {
  //             console.log(error);
  //         }
  //     );
  // }

  public showVersion() {
    const version = "Luciana - Redes Humanas S. A. | 3.0.2";
    console.log(version);
    this.notificationsService.growlNotify("info", version);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/pages.component.ts